import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Utility from '@/Common/Utility';
import RichEditor from '@/PlugableControls/RichEditor';
import PlugableControlBase from "@/Common/PlugableControlBase";
import TouchEventManager from '@/Common/TouchEventManager';
export default {
  name: "BlockPaging",
  data: function data() {
    return {
      Key: 0,
      ControlId: "",
      Name: "",
      m_UpdateKey: 1,
      ClassName: "",
      ItemIndex: 0,
      RecordPerPage: 3,
      MobileRecordPerPage: null,
      AutoPlay: false,
      Duration: 5,
      //5 秒
      StayDuration: 0,
      PlayMode: "Normal",
      //Infinite
      blockitemlist: [],
      PlayBlockItemList: [],
      m_PlayTimer: null,
      m_Hovering: false,
      m_Moving: false,
      m_UniqueClassName: "",
      m_PlayPageIndex: 0,
      m_PlayPageCount: 0,
      m_Destroyed: false,
      m_PageIndex: 0,
      m_PageCount: 0,
      m_PaddingCount: 0,
      m_TouchingClassName: "",
      m_ItemWidth: "100%",
      m_BlockItemListWidth: "100%",
      m_BlockItemList860Width: "100%",
      m_BlockItemList660Width: "100%",
      m_BlockItemList440Width: "100%",
      m_TouchEventManager: null,
      m_LastTriggerChangeTime: new Date('1999/1/1')
    };
  },
  props: ["value", "name", "EventBinder"],
  methods: {
    OnMouseOver: function OnMouseOver(e) {
      this.m_Hovering = true; //console.log("OnMouseOver");
    },
    OnMouseLeave: function OnMouseLeave(e) {
      this.m_Hovering = false; //console.log("OnMouseLeave")
    },
    ResetPagingInfo: function ResetPagingInfo() {
      this.m_PlayPageIndex = this.GetCurrentPageIndex();
      this.m_PlayPageCount = this.GetPageCount();

      if (this.PlayMode == "Normal") {
        this.m_PageIndex = this.m_PlayPageIndex;
        this.m_PageCount = this.m_PlayPageCount;
      } else {
        //Infinite
        this.ResetSourcePagingInfo();
      }
    },
    ResetSourcePagingInfo: function ResetSourcePagingInfo() {
      if (this.PlayMode == "Normal") {
        this.m_PageIndex = this.m_PlayPageIndex;
        this.m_PageCount = this.m_PlayPageCount;
      } else {
        //Infinite
        if (this.m_PlayPageIndex < this.RecordPerPage) {
          this.m_PageIndex = this.m_PlayPageIndex;
        } else if (this.m_PlayPageIndex >= this.blockitemlist.length + this.RecordPerPage) {
          this.m_PageIndex = this.m_PlayPageIndex - (this.blockitemlist.length + this.RecordPerPage);
        } else {
          this.m_PageIndex = this.m_PlayPageIndex - this.RecordPerPage;
        }

        this.m_PageCount = Math.ceil(this.blockitemlist.length / this.RecordPerPage);
      }
    },
    OnMoveToPreviousButtonClick: function OnMoveToPreviousButtonClick() {
      var _this = this;

      if (isNaN(this.m_PlayPageCount)) {
        this.ResetPagingInfo();
      }

      if (this.m_Moving == false) {
        this.m_Moving = true;
        this.MoveToPrevious();
        setTimeout(function () {
          _this.m_Moving = false;
        }, 400);
      }
    },
    OnMoveToNextButtonClick: function OnMoveToNextButtonClick() {
      var _this2 = this;

      if (isNaN(this.m_PlayPageCount)) {
        this.ResetPagingInfo();
      }

      if (this.m_Moving == false) {
        this.m_Moving = true;
        this.MoveToNext();
        setTimeout(function () {
          _this2.m_Moving = false;
        }, 400);
      }
    },
    MoveToPrevious: function MoveToPrevious() {
      var _this3 = this;

      var infiniteLastPagePaddingCount = 0; //this.ResetPagingInfo();

      if (this.PlayMode == "Normal") {
        if (this.m_PlayPageIndex > 0) {
          this.m_PlayPageIndex--;
          this.MoveToPage(this.m_PlayPageIndex);
          this.ResetSourcePagingInfo();
          this.$emit("IndexChange", this.m_PageIndex);
        }
      } else {
        if (this.m_PlayPageIndex > 0) {
          this.m_PlayPageIndex--;
          this.MoveToPage(this.m_PlayPageIndex);
          this.ResetSourcePagingInfo();
          this.$emit("IndexChange", this.m_PageIndex);
        }

        if (this.m_PlayPageIndex == 0) {
          //如果已經移到了第一頁
          infiniteLastPagePaddingCount = this.GetInfiniteLastPagePaddingCount();

          if (infiniteLastPagePaddingCount == 0) {
            //則快速回到第 Index = this.m_PlayPageCount - 1 頁
            this.m_PlayPageIndex = this.m_PlayPageCount - 1;
          } else {
            //則快速回到第 Index = this.m_PlayPageCount - 2 頁
            this.m_PlayPageIndex = this.m_PlayPageCount - 2;
          }

          setTimeout(function () {
            _this3.MoveToPage(_this3.m_PlayPageIndex, true);

            _this3.ResetSourcePagingInfo();

            _this3.$emit("IndexChange", _this3.m_PageIndex);
          }, 400);
        }
      }
    },
    MoveToNext: function MoveToNext() {
      var _this4 = this;

      //this.ResetPagingInfo(); 
      if (this.PlayMode == "Normal") {
        if (this.m_PlayPageIndex < this.m_PlayPageCount - 1) {
          this.m_PlayPageIndex++;
          this.MoveToPage(this.m_PlayPageIndex);
          this.ResetSourcePagingInfo();
          this.$emit("IndexChange", this.m_PageIndex);
        }
      } else {
        if (this.m_PlayPageIndex < this.m_PlayPageCount - 1) {
          this.m_PlayPageIndex++;
          this.MoveToPage(this.m_PlayPageIndex);
          this.ResetSourcePagingInfo();
          this.$emit("IndexChange", this.m_PageIndex);
        }

        if (this.m_PlayPageIndex == this.m_PlayPageCount - 1) {
          //如果已經移到了最後一頁
          //則快速回到第 Index = 1 頁
          this.m_PlayPageIndex = 1;
          setTimeout(function () {
            _this4.ResetSourcePagingInfo();

            _this4.MoveToPage(_this4.m_PlayPageIndex, true);

            _this4.$emit("IndexChange", _this4.m_PageIndex);
          }, 400);
        }
      }
    },
    MoveToCurrent: function MoveToCurrent() {
      this.ResetPagingInfo();
      this.MoveToPage(this.m_PlayPageIndex);
    },
    GetPageCount: function GetPageCount() {
      var pageCount = 0;
      pageCount = Math.ceil(this.$refs.BlockItemList.clientWidth / this.$refs.BlockItemListContainer.clientWidth);
      return pageCount;
    },
    GetCurrentPageIndex: function GetCurrentPageIndex() {
      var pageIndex = 0;
      var left;
      var containerWidth;

      if (this._isDestroyed) {
        return 0;
      }

      left = window.getComputedStyle(this.$refs.BlockItemList).getPropertyValue("left");
      left = new Number(left.replace("px", ""));
      containerWidth = this.$refs.BlockItemListContainer.clientWidth;
      pageIndex = Math.abs(Math.round(left / containerWidth));
      return pageIndex;
    },
    GetCurrentRecordPerPage: function GetCurrentRecordPerPage() {
      var recordPerPage = this.RecordPerPage;
      var itemWidth;
      var containerWidth;

      if (this.$refs.BlockItemList.children.length > 0) {
        itemWidth = this.$refs.BlockItemList.children[0].clientWidth;
        containerWidth = this.$refs.BlockItemListContainer.clientWidth;
        recordPerPage = Math.round(containerWidth / itemWidth);
      }

      return recordPerPage;
    },
    MoveToPage: function MoveToPage(pageIndex, moveDirectly) {
      var _this5 = this;

      if (moveDirectly == true) {
        this.m_TouchingClassName = "Directly";
      }

      this.$refs.BlockItemList.style.left = -(pageIndex * 100) + "%";
      setTimeout(function () {
        _this5.m_TouchingClassName = "";
      }, 10);
    },
    MoveToSourcePage: function MoveToSourcePage(index, moveDirectly) {
      //console.log(`MoveToSourcePage : index :${index}`)
      if (this.PlayMode == "Normal") {
        if (index >= 0 && index < this.m_PlayPageCount) {
          this.m_PlayPageIndex = index;
          this.MoveToPage(this.m_PlayPageIndex, moveDirectly);
          this.ResetSourcePagingInfo();
          this.$emit("IndexChange", this.m_PageIndex);
        }
      } else {
        //Infinite
        this.m_PlayPageIndex = index + this.RecordPerPage;
        this.MoveToPage(this.m_PlayPageIndex, moveDirectly);
        this.ResetSourcePagingInfo();
        this.$emit("IndexChange", this.m_PageIndex);
      }
    },
    GetSourcePageIndex: function GetSourcePageIndex(playPageIndex) {
      var sourcePageIndex = 0;

      if (this.PlayMode == "Normal") {
        sourcePageIndex = playPageIndex;
      } else {
        //Infinite
        if (playPageIndex < this.m_PlayPageCount - 1) {
          sourcePageIndex = playPageIndex + 1;
        } else {
          sourcePageIndex = 0;
        }
      }
    },
    ConvertDateTimeToText: function ConvertDateTimeToText(dateTimeObj) {
      var dateTimeText;
      dateTimeText = dateTimeObj.toString("yyyy/MM/dd HH:mm:ss.sss");
      return dateTimeText;
    },
    SetPlayBlockItemList: function SetPlayBlockItemList() {
      var blockItem;
      var index;
      var sartIndex, i;
      var lastPlayPageCount;
      var paddingCount;

      if (this.PlayMode == "Normal") {
        this.PlayBlockItemList = this.blockitemlist;

        for (i = 0; i < this.PlayBlockItemList.length; i++) {
          this.PlayBlockItemList[i].SourceIndex = i;
        }
      } else {
        //Infinite
        this.PlayBlockItemList = [];
        sartIndex = this.blockitemlist.length - this.RecordPerPage;

        for (i = 0; i < this.RecordPerPage; i++) {
          index = sartIndex + i;

          if (index >= 0) {
            blockItem = this.blockitemlist[index];
            blockItem.SourceIndex = index;
            this.PlayBlockItemList.push(blockItem);
          }
        }

        for (i = 0; i < this.blockitemlist.length; i++) {
          blockItem = this.blockitemlist[i];
          blockItem.SourceIndex = index;
          this.PlayBlockItemList.push(blockItem);
        }

        if (this.PlayBlockItemList % this.RecordPerPage == 0) {//表示剛好補滿 不用再增加一頁
          //Do Nothing
        } else {
          lastPlayPageCount = this.PlayBlockItemList.length % this.RecordPerPage;
          paddingCount = this.RecordPerPage - lastPlayPageCount;

          for (i = 0; i < paddingCount; i++) {
            if (i < this.blockitemlist.length) {
              blockItem = this.blockitemlist[i];
              this.PlayBlockItemList.push(blockItem);
            }
          }
        }
      }
    },
    GetInfiniteLastPagePaddingCount: function GetInfiniteLastPagePaddingCount() {
      var lastPlayPageCount;
      var paddingCount;
      lastPlayPageCount = (this.blockitemlist.length + this.RecordPerPage) % this.RecordPerPage;
      paddingCount = this.RecordPerPage - lastPlayPageCount;
      return paddingCount;
    },
    SetBlockItemListWidth: function SetBlockItemListWidth() {
      var pageCount = 1;
      var itemWidth;
      var itemCount;
      var fullItemCount = 0;
      itemCount = this.PlayBlockItemList.length;

      if (this.PlayBlockItemList.length == 0) {
        return;
      }

      this.m_ItemWidth = Math.round(100 * 100 / this.PlayBlockItemList.length) / 100 + "%";
      pageCount = Math.ceil(this.PlayBlockItemList.length / this.RecordPerPage);
      fullItemCount = pageCount * this.RecordPerPage;
      this.m_BlockItemListWidth = pageCount * 100 * (itemCount / fullItemCount) + "%";

      if (this.MobileRecordPerPage == null) {
        if (this.RecordPerPage >= 2) {
          pageCount = Math.ceil(this.PlayBlockItemList.length / 2);
          fullItemCount = pageCount * 2;
        } else {
          pageCount = this.PlayBlockItemList.length / 1;
          fullItemCount = pageCount * 1;
        }

        this.m_BlockItemList860Width = pageCount * 100 * (itemCount / fullItemCount) + "%";
        pageCount = this.PlayBlockItemList.length / 1;
        fullItemCount = pageCount * 1;
        this.m_BlockItemList660Width = pageCount * 100 * (itemCount / fullItemCount) + "%";
        this.m_BlockItemList440Width = this.m_BlockItemList660Width;
      } else {
        pageCount = Math.ceil(this.PlayBlockItemList.length / this.MobileRecordPerPage);
        fullItemCount = pageCount * this.MobileRecordPerPage;
        this.m_BlockItemList860Width = pageCount * 100 * (itemCount / fullItemCount) + "%";
        this.m_BlockItemList660Width = this.m_BlockItemList860Width;
        this.m_BlockItemList440Width = this.m_BlockItemList660Width;
      }
    },
    Play: function Play() {
      var _this6 = this;

      if (this.m_Destroyed) {
        return;
      }

      if (!this.AutoPlay) {
        this.m_PlayTimer = setTimeout(function () {
          if (_this6._isDestroyed) {
            return;
          }

          _this6.Play();
        }, 3000);
        return;
      } else if (this.m_Hovering || this.m_Moving) {
        this.m_PlayTimer = setTimeout(function () {
          if (_this6._isDestroyed) {
            return;
          }

          _this6.Play();
        }, 1000);
        return;
      } else {
        //console.log("StayDuration=" + this.StayDuration);
        if (this.StayDuration >= this.Duration) {
          if (this.blockitemlist.length > 1) {
            //console.log("MoveToNext");
            this.MoveToNext();
            this.StayDuration = 0;
          }
        } else {
          this.StayDuration += 1;
        }

        this.m_PlayTimer = setTimeout(function () {
          if (_this6._isDestroyed) {
            return;
          }

          _this6.Play();
        }, 1000 //this.Duration * 1000
        );
      }
    },
    OnResize: function OnResize(e) {
      if (!this.IsMobile()) {
        this.MoveToPage(0);
      }

      this.ResetPagingInfo();
      this.SetBlockItemListWidth();
    },
    IsMobile: function IsMobile() {
      var isMobile = /iphone|ipod|android|blackberry|fennec/.test(navigator.userAgent.toLowerCase());
      return isMobile;
    },
    OnTouchStart: function OnTouchStart(e, options) {
      this.m_TouchStartX = window.getComputedStyle(this.$refs.BlockItemList).getPropertyValue("left");
      this.m_TouchStartX = new Number(this.m_TouchStartX.replace("px", ""));
      this.m_TouchingClassName = "Touching";
    },
    OnTouchMove: function OnTouchMove(e, options) {
      e.preventDefault();
      this.$refs.BlockItemList.style.left = this.m_TouchStartX + options.MoveX + "px";
    },
    OnTouchEnd: function OnTouchEnd(e, options) {
      var _this7 = this;

      var threshold = 0.2;
      this.m_TouchingClassName = "TouchingChange";

      if (this.$el.clientWidth > 660) {
        threshold = 0.2;
      }

      if (Math.abs(options.MoveX) / this.$refs.Element.clientWidth > threshold) {
        //有移動
        if (options.MoveX > 0) {
          //要往前一頁
          if (this.PlayMode == "Normal") {
            if (this.m_PlayPageIndex > 0) {
              this.m_PlayPageIndex--;
              this.MoveToPage(this.m_PlayPageIndex);
            } else {
              this.MoveToPage(this.m_PlayPageIndex);
            }
          } else {
            this.MoveToPrevious();
          }
        } else {
          //要往下一頁
          if (this.PlayMode == "Normal") {
            if (this.m_PlayPageIndex < this.m_PlayPageCount - 1) {
              this.m_PlayPageIndex++;
              this.MoveToPage(this.m_PlayPageIndex);
            } else {
              this.MoveToPage(this.m_PlayPageIndex);
            }
          } else {
            this.MoveToNext();
          }
        }

        this.ResetSourcePagingInfo();
        this.$emit("IndexChange", this.m_PageIndex);
      } else {
        //this.MoveToPage(this.m_PageIndex);
        this.MoveToCurrent();
      }

      this.StayDuration = 0;
      setTimeout(function () {
        _this7.m_TouchingClassName = "";
      }, 500);
    },
    MoveToIndex: function MoveToIndex(index) {
      var _this8 = this;

      var sourcePageIndex;
      var recordPerPage;
      var moveDirectly = false; //console.log("OnUserChangeIndex , index=" + index);

      this.m_PlayPageCount = this.GetPageCount();
      this.ItemIndex = index;
      recordPerPage = this.GetCurrentRecordPerPage();
      sourcePageIndex = Math.floor(index / recordPerPage);

      if (sourcePageIndex == 0) {
        moveDirectly = true;
      }

      this.MoveToSourcePage(sourcePageIndex, true);

      if (this.m_PlayTimer != null) {
        this.StayDuration = 0;
        clearTimeout(this.m_PlayTimer);

        if (this.AutoPlay) {
          if (this.blockitemlist.length > 0) {
            this.m_PlayTimer = setTimeout(function () {
              _this8.Play();
            }, 0);
          }

          ;
        }
      }
    },
    OnUserChangeIndex: function OnUserChangeIndex(index) {
      var _this9 = this;

      var sourcePageIndex;
      var recordPerPage;
      var moveDirectly = false; //console.log("OnUserChangeIndex , index=" + index);

      this.ItemIndex = index;
      recordPerPage = this.GetCurrentRecordPerPage();
      sourcePageIndex = Math.floor(index / recordPerPage);

      if (sourcePageIndex == 0) {
        moveDirectly = true;
      }

      this.MoveToSourcePage(sourcePageIndex, moveDirectly);

      if (this.m_PlayTimer != null) {
        this.StayDuration = 0;
        clearTimeout(this.m_PlayTimer);

        if (this.AutoPlay) {
          if (this.blockitemlist.length > 0) {
            this.m_PlayTimer = setTimeout(function () {
              _this9.Play();
            }, 0);
          }

          ;
        }
      }
    },
    OnBannerItemClick: function OnBannerItemClick(item) {
      console.log("OnBannerItemClick item.SourceIndex=" + item.SourceIndex);
      this.$emit("ItemClick", item.SourceIndex, item, this.$el);
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    var _this10 = this;

    //繼承 PlugableControlBase
    PlugableControlBase.call(this);

    if (this.value != null) {
      Object.assign(this.$data, this.value);
      this.SetPlayBlockItemList();
      this.Key++;
    }

    this.m_TouchEventManager = new TouchEventManager();
    this.SetBlockItemListWidth();

    if (this.$bus != null) {
      this.$bus.$on("AppResize", this.OnResize);
    } else {
      window.addEventListener("resize", this.OnResize);
    }

    setTimeout(function () {
      if (_this10._isDestroyed) {
        return;
      }

      _this10.ResetPagingInfo();

      if (_this10.PlayMode == "Infinite") {
        _this10.m_PlayPageIndex = 1;

        _this10.MoveToPage(_this10.m_PlayPageIndex, true);
      }

      _this10.m_TouchEventManager.Attach(_this10.$refs.BlockItemListContainer);

      _this10.SetBlockItemListWidth();

      _this10.Key++;
      _this10.m_TouchEventManager.TouchStartHandler = _this10.OnTouchStart;
      _this10.m_TouchEventManager.TouchMoveHandler = _this10.OnTouchMove;
      _this10.m_TouchEventManager.TouchEndHandler = _this10.OnTouchEnd;
    }, 100);
    setTimeout(function () {
      _this10.m_PlayPageCount = _this10.GetPageCount();

      _this10.SetBlockItemListWidth();

      _this10.Key++;
    }, 1000);

    if (this.AutoPlay) {
      if (this.blockitemlist.length > 0) {
        this.m_PlayTimer = setTimeout(function () {
          _this10.Play();
        }, 1000);
      }

      ;
    }
  },
  beforeMounted: function beforeMounted() {},
  beforeDestroy: function beforeDestroy() {
    //console.log("BlockPaging beforeDestroy");
    this.m_Destroyed = true;

    if (this.$bus != null) {
      this.$bus.$off("AppResize", this.OnResize);
    } else {
      window.removeEventListener("resize", this.OnResize);
    }

    this.m_TouchEventManager = null;
  },
  components: {
    RichEditor: RichEditor
  },
  created: function created() {
    var eventHandlersObj;
    this.m_UniqueClassName = "BP_" + Utility.GenerateSerialNumber();

    if (this.EventBinder != null) {
      this.EventBinder(this.OnUserChangeIndex);
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      var _this11 = this;

      var currTime = new Date();
      var span;
      span = currTime - this.m_LastTriggerChangeTime;

      if (span > 100) {
        if (newVal != null) {
          Object.assign(this.$data, newVal);
        }

        if (this.m_PlayTimer != null) {
          this.StayDuration = 0;
          clearTimeout(this.m_PlayTimer);
        }

        this.SetPlayBlockItemList();
        this.$forceUpdate();
        setTimeout(function () {
          this.SetBlockItemListWidth();
        }.bind(this), 1);
        setTimeout(function () {
          _this11.ResetPagingInfo();

          _this11.MoveToPage(1, true);

          _this11.m_PageIndex = 0;
        }, 100);

        if (this.blockitemlist.length > 0) {
          this.StayDuration = 0;
          this.m_PlayTimer = setTimeout(function () {
            _this11.Play();
          }, 1000);
        }

        ;
      } else {
        alert("Span=" + span);
      }
    }
  },
  computed: {}
};